import React from 'react';
import * as R from 'ramda';
import { compose, setDisplayName, withProps, branch, renderNothing } from 'recompose';

import { qaSel, extractLocaleData, sanitizeHTML } from '../../common/utils';

const customBranding = ({ enabledFeatures, customBranding }) => ({
  customHtml: R.pipe(
    extractLocaleData,
    sanitizeHTML
  )(customBranding.header_html),
  customCss: R.replace(/\u003Cstyle\u003E|\u003C\/style\u003E/g, '', extractLocaleData(customBranding.header_css)),
  showCustomHeader: (R.contains('additional_advanced_branding', enabledFeatures) && !R.isEmpty(customBranding.header_html))
});

const CustomHeader = compose(
  withProps(customBranding),
  branch(R.propEq('showCustomHeader', false), renderNothing),
  setDisplayName('Header')
)((({ customHtml, customCss }) => (
  <React.Fragment>
    <style dangerouslySetInnerHTML={{ __html: customCss }}/>
    <div
      id="custom-header"
      data-qa={qaSel('custom-header')}
      className='c-custom-header'
      dangerouslySetInnerHTML={{ __html: customHtml }} />
  </React.Fragment>
)));

export default CustomHeader;
